// api.adn-test.mobvista.com, api.adn.mobvista.com
import { NODE_ENV } from '@com/config/env'

export const ssHostList = {
  // 开发环境与测试环境都是用测试服务器
  development: '//jwen-ss-api.mintegral.com', // ss-api-test.mintegral.com
  test: '//jwen-ss-api.mintegral.com', // ss-api-test.mintegral.com
  production: '//ss-api.mintegral.com',
  'pre-release': '//ss-api.mintegral.com'
}
export const ssHost = ssHostList[NODE_ENV]

export const ssPortalHostList = {
  // 开发环境与测试环境都是用测试服务器
  development: '//api.jwen.mobvista.com', // api.adn-test.mobvista.com
  test: '//api.jwen.mobvista.com', // api.adn-test.mobvista.com
  production: '//api.adn.mobvista.com',
  prerelease: '//api.adn.mobvista.com'
}
export const ssPortalHost = ssPortalHostList[NODE_ENV]
